import * as axios from "axios";
import { getAuthHeader } from "./../utils";

export const addDetail = (model: any) => {
  const url = `${process.env.REACT_APP_BASE_URL}encashment/add`;
  return axios.post(url, model, getAuthHeader()).then(
    (response: any) => {
      return response.data;
    },
    (error: any) => {
      alert(error.Message);
    }
  );
};

export const getDetail = (id: number) => {
  const url = `${process.env.REACT_APP_BASE_URL}encashment/detail?id=${id}`;
  return axios.get(url, getAuthHeader()).then(
    (response: any) => {
      return response.data;
    },
    (error: any) => {
      alert(error.Message);
    }
  );
};

export const getList = (year: string) => {
  const url = `${process.env.REACT_APP_BASE_URL}encashment/list?yr=${year}`;
  return axios.get(url, getAuthHeader()).then(
    (response: any) => {
      return response.data;
    },
    (error: any) => {
      alert(error.Message);
    }
  );
};

export const addComment = (model: any) => {
  const url = `${process.env.REACT_APP_BASE_URL}encashment/add-comment`;
  return axios.post(url, model, getAuthHeader()).then(
    (response: any) => {
      return response.data;
    },
    (error: any) => {
      alert(error.Message);
    }
  );
};
